<mat-form-field
    class="vc-mat-form-field vc-mat-chips-autocomplete"
    [class.vc-readonly-field]="readonly"
    [class.vc-filter-minimal-styles]="minimalStyles"
    [class.vc-autocomplete-invalid]="!valid && touched && !readonly && !disabled"
    [class.vc-no-label]="!label || label === ''">
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid
        #chipGrid
        [errorStateMatcher]="errorStateMatcher"
        [disabled]="disabled"
        [required]="required"
        [attr.aria-label]="label"
        (blur)="touched = true; validate()">
        @for (val of values; track $index) {
            <mat-chip-row
                class="vc-chips-autocomplete-container-chip"
                color="primary"
                [removable]="canDeleteChip"
                (removed)="remove(val, $index)">
                @if (!!prefixIconRenderer && prefixIconRenderer(val) !== '') {
                    <mat-icon
                        class="vc-chips-autocomplete-prefix"
                        [class.material-icons-outlined]="prefixIconUseOutline">
                        {{ prefixIconRenderer(val) }}
                    </mat-icon>
                }
                <vc-tooltip-text
                    class="vc-chips-autocomplete-container-tooltip"
                    [text]="itemRenderer(val)"
                    [tooltipMessage]="itemRenderer(val)"></vc-tooltip-text>
                @if (!disabled && !readonly && canDeleteChip) {
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
            </mat-chip-row>
        }
        <input
            #autocompleteInput
            [(ngModel)]="filterValue"
            [placeholder]="placeholder"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipGrid"
            [attr.aria-invalid]="!valid && touched"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [attr.aria-describedby]="ariaDescribedBy"
            [readonly]="readonly"
            (blur)="touched = true"
            (ngModelChange)="inputValueChanges()" />
    </mat-chip-grid>
    @if (suffixIcon && (!values || values.length === 0)) {
        <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
    }
    <mat-autocomplete #auto="matAutocomplete" [panelWidth]="panelWidth" (optionSelected)="selectValue($event)">
        @for (value of filteredOptions; track value) {
            <mat-option [value]="value" class="vc-dropdown-option">
                <vc-tooltip-text
                    class="vc-chips-autocomplete-container-tooltip"
                    [text]="itemRenderer(value)"
                    [tooltipMessage]="itemRenderer(value)"></vc-tooltip-text>
            </mat-option>
        }
    </mat-autocomplete>
    @if (!valid && touched && !disabled && !readonly) {
        <mat-hint class="vc-error-message">
            {{ errorMessage }}
        </mat-hint>
    }
</mat-form-field>
